<div class="modalForm" [formGroup]="form">
  <div class="flex flex-column gap-2 mb-3 g-col-1-3">
    <label for="emailList" class="font-semibold w-full">
      {{ "protocols.send_protocol_email.email_recipients" | translate }}
    </label>
    <p-multiSelect
      [options]="users()"
      id="emailList"
      formControlName="emailList"
      [filter]="true"
      filterMatchMode="contains"
      appendTo="body"
      styleClass="w-full"
      [style]="{ 'min-height': '37px' }"
    >
      <ng-template let-values #selectedItems>
        @for (selectedEmail of values; track selectedEmail) {
          {{ selectedEmail.email }} ,
        }
      </ng-template>
      <ng-template let-email #item>
        {{ email.email }}
      </ng-template>
    </p-multiSelect>
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button
      [buttonText]="translate.instant('common.send')"
      [disabled]="!form.valid"
      (click)="sendEmail()"
    ></app-button>
  </div>
</div>
